import { APIStatus } from '@flowwai-frontend/shared/api-common'
import cn from 'classnames'
import { observer } from 'mobx-react'
import React, { useState } from 'react'

import {
   CloseButton,
   CloseButtonSubVariant
} from '@flowwai-frontend/design-system'
import { isAPIFetching } from '@flowwai-frontend/shared/utils/common'

import { ReactBaseModalContainer } from '../ReactBaseModalContainer'
import './styles.css'

interface ConfirmationModalProps {
   isOpen?: boolean
   apiStatus: APIStatus
   onCloseModal?: () => void
   renderConfirmationCard: () => React.ReactElement | string
   hideCloseIcon?: boolean
   containerClassName?: string
   modalContainerClassName?: string
   shouldCloseOnOverlayClick?: boolean
}

const ConfirmationModal = (
   props: ConfirmationModalProps
): React.ReactElement | null => {
   const {
      isOpen,
      onCloseModal: onCloseModalPropFunc,
      renderConfirmationCard,
      apiStatus,
      shouldCloseOnOverlayClick,
      hideCloseIcon = false
   } = props

   const [isModalOpen, setIsModalOpen] = useState(false)
   const isLoading = isAPIFetching(apiStatus)

   const onCloseModal = () => {
      if (!isLoading) {
         setIsModalOpen(false)
         onCloseModalPropFunc && onCloseModalPropFunc()
      }
   }

   const renderCloseButton = (): React.ReactElement => (
      <CloseButton
         subVariant={CloseButtonSubVariant.Gray}
         size='Large'
         onClick={onCloseModal}
      />
   )

   return (
      <ReactBaseModalContainer
         onClickCloseIcon={onCloseModal}
         isOpen={isModalOpen || isOpen}
         className={cn(
            `shared-confirmation-modal`,
            props.modalContainerClassName
         )}
         overlayClassName={cn(
            'shared-confirmation-overlay',
            props.containerClassName
         )}
         closeIconClass={'shared-confirmation-modal-close-icon'}
         hideCloseIcon={hideCloseIcon}
         customCloseIcon={renderCloseButton}
         shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      >
         {renderConfirmationCard()}
      </ReactBaseModalContainer>
   )
}

export default observer(ConfirmationModal)
